import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import Button from '@material-ui/core/Button';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import ShoppingCartIcon from '@material-ui/icons/ShoppingCart';
import Divider from '@material-ui/core/Divider';
import { Typography } from '@material-ui/core';
import { Link } from 'react-router-dom';
import ReactPixel from 'react-facebook-pixel';
import strings from './components/language/language';

const styles = (theme) => ({
  root: {
    position: 'sticky',
    top: '15%',
  },
  title: {
    fontSize: 30,
    fontWeight: 500,
    [theme.breakpoints.down('sm')]: {
      fontSize: 22,
    },
  },
  price: {
    [theme.breakpoints.down('sm')]: {
      marginTop: 50,
    },
    [theme.breakpoints.down('md')]: {
      marginTop: 35,
    },
  },
  item: {
    padding: '20px 0',
    [theme.breakpoints.down('sm')]: {
      padding: '27px 0',
    },
  },
  itemCount: {
    marginRight: 25,
    color: 'red',
    fontWeight: 'bold',
  },
  close: {
    position: 'relative',
    bottom: 3,
    width: 15,
  },
  iconClose: {
    width: 20,
    height: 20,
  },
  button: {
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%',
    padding: '20px 50px',
    fontWeight: '600',
    color: '#fff !important',
    backgroundColor: '#70142b',
    textTransform: 'capitalize',
    margin: '25px auto',
    borderRadius: theme.shape.borderRadius * 9,
    '&:hover': {
      backgroundColor: '#70142b',
    },
    [theme.breakpoints.down('sm')]: {
      padding: '13px 35px',
    },
  },
});

class Order extends Component {
  render() {
    const { classes, promoCode, total } = this.props;

    // promo code for order item price
    const promoCodePrice = (price) => {
      const promoCodeDiscountOrder = (price / 100) * promoCode;
      const promoCodeOrder = price - promoCodeDiscountOrder;
      return (
        promoCode && (
          <span style={{ marginLeft: 10 }}>
            {Number.parseFloat(promoCodeOrder.toFixed(2))}
          </span>
        )
      );
    };

    // promo code for total price
    const promoCodeDiscountTotal = (total / 100) * promoCode;
    const promoCodeTotal = total - promoCodeDiscountTotal;

    return (
      <div className='order-checkout'>
        <Typography className={classes.title} variant='h2' component='h2'>
          {strings.order}
        </Typography>
        <List>
          {this.props.cart.map((item) => (
            <React.Fragment>
              <ListItem className={classes.item}>
                {/* <ListItemText primary={`${item.count} ✖ ${item.name}`} /> */}
                <span className={classes.itemCount}>{item.count}x</span>
                <span>{item.name}</span>
                <ListItemSecondaryAction>
                  <div className={classes.price}>
                    {/* <OrderQuantity /> */}
                    <span
                      style={{
                        // marginRight: 25,
                        textDecoration: promoCode ? 'line-through' : 'none',
                      }}
                    >
                      {' '}
                      {item.price_of_one} {strings.currency}
                    </span>
                    {promoCodePrice(item.price_of_one)} {strings.currency}
                  </div>
                </ListItemSecondaryAction>
              </ListItem>
              <Divider />
            </React.Fragment>
          ))}
        </List>
        {this.props.cart.length > 0 && (
          <Link to='/checkout' style={{ textDecoration: 'none' }}>
            <Button
              onClick={() => {
                ReactPixel.trackCustom(
                  `desktop - ${this.props.restaurant_name} - go to checkout page`,
                  {
                    userID: this.props.messenger_user_id,
                  }
                );
                ReactPixel.trackCustom('desktop - go to checkout page');
              }}
              className={classes.button}
              style={{ backgroundColor: this.props.color }}
            >
              <span style={{ position: 'relative', bottom: 3 }}>
                <ShoppingCartIcon
                  style={{
                    position: 'relative',
                    marginRight: 5,
                    top: 5,
                  }}
                />
                {strings.checkout}
              </span>
              <span
                style={{
                  textDecoration: promoCode ? 'line-through' : 'none',
                }}
              >
                {total} {strings.currency}
              </span>
              {promoCode && (
                <span>
                  {promoCodeTotal.toFixed(2)} {strings.currency}
                </span>
              )}
            </Button>
          </Link>
        )}
      </div>
    );
  }
}

export default withStyles(styles)(Order);



// WEBPACK FOOTER //
// ./src/Order.js